import React from 'react';
import { Typography, useMediaQuery } from '@mui/material';
import Link from '../../../../../elements/Link';
import DS_Accordion from '../../../../../elements/DS_Accordion/Accordion';
import DS_ControlledDesktopAccordion from './DesktopControlledAccordion';
import {
  StyledListItem,
  StyledMenuLinks,
  StyledWrapperAccordion,
  StyledDirectLinks,
  StyledDivider,
} from './MenuLinksStyles';

const MenuLinks = ({ menuOne, menuOneLabel, menuTwo, menuTwoLabel, directLinks, newsBanner, ctaButtonURL }) => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const [expandedPanel, setExpandedPanel] = React.useState(false);

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  const menuData = [
    menuOne ? { menu: menuOne, label: menuOneLabel } : null,
    menuTwo ? { menu: menuTwo, label: menuTwoLabel } : null,
  ].filter(menuItem => menuItem !== null);

  const renderMenuLinks = menu => {
    return (
      <>
        {menu.map((item, index) => (
          <StyledListItem key={`${item.id}-${index}`} data-test="styled-list-item">
            <Link url={item.url}>{item.title}</Link>
          </StyledListItem>
        ))}
      </>
    );
  };

  return (
    <StyledMenuLinks>
      {menuData.length > 0
        ? menuData.map((data, index) => (
            <div key={`${data.label}-${index}`}>
              <StyledWrapperAccordion data-test="styled-accordion">
                {isDesktop ? (
                  <DS_ControlledDesktopAccordion
                    newsBanner={newsBanner}
                    data={{
                      label: data.label,
                      value: renderMenuLinks(data.menu),
                      expanded: expandedPanel === index,
                      onChange: handleAccordionChange(index),
                    }}
                  />
                ) : (
                  <DS_Accordion
                    data={{
                      label: data.label,
                      value: renderMenuLinks(data.menu),
                      isOpenedByDefault: false,
                    }}
                  />
                )}
              </StyledWrapperAccordion>
              <StyledDivider />
            </div>
          ))
        : null}
      {directLinks?.length > 0
        ? directLinks
            .filter(link => link.url !== ctaButtonURL)
            .map((link, index) => (
              <StyledDirectLinks key={`${link.id}-${index}`}>
                <Typography component={Link} variant="DS_labelSmallBold" url={link.url}>
                  {link.title}
                </Typography>
                <StyledDivider />
              </StyledDirectLinks>
            ))
        : null}
    </StyledMenuLinks>
  );
};

export default MenuLinks;
